import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import { Subject } from 'rxjs';
import {User} from "../models";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {Service} from "../models/service";
import {ComponentTitleService} from "../services/componentTitle.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CustomerContactDetailsDialogComponent} from "./dialog/customerContactDetailsDialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
    templateUrl: './customerPersonalData.component.html',
    styleUrls: ['./customerPersonalData.component.scss']
})
export class CustomerPersonalDataComponent implements OnDestroy, OnInit {
    id: string;
    user: User;
    dialogRef: any;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        public _matDialog: MatDialog,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Customers');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.user = this.route.snapshot.data.userData;
        this.componentTitleService.addPart(this.user.firstName + ' ' + this.user.lastName);
    }

    ngOnDestroy(): void {

    }

    showCustomerContactDetails(customer: User) {
        this.dialogRef = this._matDialog.open(CustomerContactDetailsDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                customer: customer,
            },
            width: '550px',
        });
    }
}
